import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { StatBlockComponent } from '@rma/dashboard/generic/ui/stat-block';
import { StaticImageUrlPipe } from '@rma/dashboard/generic/util/pipes/static-image-url';
import { SM_RENOWNED_LOGO_PATH } from '@rma/dashboard/layout/public/util-layout';

@Component({
  selector: 'rma-my-subscription-reviews-card',
  imports: [TranslocoModule, StaticImageUrlPipe, StatBlockComponent],
  templateUrl: './my-subscription-reviews-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MySubscriptionReviewsCardComponent {
  @Input() reviews: number | null = null;
  @Input() exposures: number | null = null;

  protected readonly smRenownedLogoPath = SM_RENOWNED_LOGO_PATH;
}
